import React, { useEffect, useState } from "react";
import Header from "../../directives/header";
import Footer from "../../directives/footer";
import Sidebar from "../../directives/sidebar";
import DataTable, { createTheme } from "react-data-table-component";
import {
  getAllFaqList,
  createFaqAction,
  updateFaqAction,
  deleteFaqAction,
} from "../../Action/action";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";

createTheme("lightTheme", {
  palette: {
    mode: "light",
    text: {
      primary: "#000000",
      secondary: "#555555",
    },
    background: {
      default: "#0B1739",
    },
  },
});

const FaqList = () => {
  const [faqList, setFaqList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [form, setForm] = useState({
    question: "",
    answer: "",
  });

  // Fetch FAQs
  const getAllFaq = async () => {
    setLoading(true);
    const res = await getAllFaqList();
    if (res?.status) {
      setFaqList(res.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAllFaq();
  }, []);

  // Validation
  const validateFaqForm = () => {
    if (!form.question.trim()) {
      toast.error("Question is required");
      return false;
    }
    if (!form.answer.trim()) {
      toast.error("Answer is required");
      return false;
    }
    return true;
  };

  // Create or Update
  const handleSubmit = async () => {
    if (!validateFaqForm()) return;

    try {
      let res;

      if (isEdit) {
        res = await updateFaqAction({ _id: editingId, ...form });
      } else {
        res = await createFaqAction(form);
      }

      if (res?.status) {
        toast.success(
          isEdit ? "FAQ updated successfully!" : "FAQ created successfully!"
        );

        setOpenModal(false);
        setIsEdit(false);
        setEditingId(null);
        setForm({ question: "", answer: "" });

        getAllFaq();
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  // Edit
  const handleEdit = (row) => {
    setIsEdit(true);
    setEditingId(row._id);
    setForm({
      question: row.question,
      answer: row.answer,
    });
    setOpenModal(true);
  };

  // Delete
  const handleDelete = async (id) => {

     try {
          const confirm = await Swal.fire({
            title: "Confirm Action",
            text:  "Are you sure you want to delete this FAQ?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: `Yes, delete it!`,
            cancelButtonText: "No, cancel",
          });
    
          if (!confirm.isConfirmed) return;
    
          const res = await deleteFaqAction({ _id: id });
          if (res.status) {
            toast.success(res.msg);
            getAllFaq();
          }
        } catch (error) {
          toast.error(error.message || "Failed to delete FAQ");
        }
  };

  const columns = [
    {
      name: "#",
      cell: (row, index) => index + 1,
      width: "70px",
    },
    {
      name: "Question",
      selector: (row) => row.question,
      wrap: true,
    },
    {
      name: "Answer",
      selector: (row) => row.answer,
      wrap: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-info me-2"
            onClick={() => handleEdit(row)}
          >
            Edit
          </button>

          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(row._id)}
          >
            Delete
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="wrapper">
      <Toaster />
      <Header />
      <Sidebar />

      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box">
              <div className="box-header d-flex justify-content-between align-items-center">
                <h3 className="box-title">FAQ List</h3>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setIsEdit(false);
                    setForm({ question: "", answer: "" });
                    setOpenModal(true);
                  }}
                >
                  + Add FAQ
                </button>
              </div>

              <div className="box-body">
                <DataTable
                  columns={columns}
                  data={faqList}
                  pagination
                  highlightOnHover
                  progressPending={loading}
                  theme="lightTheme"
                />
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Modal */}
      {openModal && (
        <div
          className="modal fade show d-block"
          style={{ background: "#00000080" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5>{isEdit ? "Edit FAQ" : "Create FAQ"}</h5>
                <button
                  className="btn-close"
                  onClick={() => setOpenModal(false)}
                />
              </div>

              <div className="modal-body">
                <label className="form-label">Question</label>
                <input
                  className="form-control mb-3"
                  value={form.question}
                  onChange={(e) =>
                    setForm({ ...form, question: e.target.value })
                  }
                />

                <label className="form-label">Answer</label>
                <textarea
                  className="form-control"
                  value={form.answer}
                  onChange={(e) =>
                    setForm({ ...form, answer: e.target.value })
                  }
                />
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setOpenModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-success" onClick={handleSubmit}>
                  {isEdit ? "Update" : "Create"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default FaqList;
